module.exports = __webpack_public_path__ + "static/media/Chevron-Right.9bb36f91.svg";